import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const links = [
  { to: "/", label: "Home" },
  { to: "/properties", label: "Properties" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  React.useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className="glass-nav sticky top-0 z-50" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-28 md:h-32 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="nav-logo" aria-label="AMPM Living home">
          <img
            src="https://customer-assets.emergentagent.com/job_hull-lets/artifacts/66fhiyot_Logo%20new.png"
            alt="AMPM Living"
            className="h-24 md:h-32 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium transition-colors ${
                  isActive ? "text-[var(--text-primary)]" : "text-[var(--text-secondary)] hover:text-[var(--text-primary)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/admin" data-testid="nav-admin-link" className="btn-outline ml-3 !py-2 !px-4 text-sm">
            Admin
          </Link>
        </nav>

        <button
          className="md:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <List size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[var(--border-subtle)] bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`nav-mobile-${l.label.toLowerCase()}-link`}
                className={({ isActive }) =>
                  `py-2 text-base font-medium ${isActive ? "text-[var(--text-primary)]" : "text-[var(--text-secondary)]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/admin" className="btn-outline mt-2 text-center justify-center" data-testid="nav-mobile-admin-link">Admin</Link>
          </div>
        </div>
      )}
    </header>
  );
};
